import utils from '../utils'

let utagData = {
  siteSection: 'live',
  screenName: '/live/',
  siteType: 'responsive web',
  siteHier: 'video|live',
  pageType: 'video_landing',
  brandPlatformId: utils.isMobile() ? 'etlive_site_mweb' : 'etlive_site_desktop',
  userState: 'not authenticated',
  userType: 'anon',
  pageViewGuid: utils.createGuid(),
  siteEdition: 'us',
  deviceType: utils.isMobile() ? 'mobile' : 'desktop',
  deviceId: '<diviceId>'
}

export default utagData
